// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3lhim","ranges":"BmiRanges_ranges__2krue"};